import {Injectable} from "@angular/core";
import {SignupStatusData} from "./signup-status.data";
import {SignupService} from "./signup.service";

export enum SignupPages {
    WELCOME,
    CONTRACT,
    BILLING,
    COMPLETE,
    FAILED,
    EXPIRED
}

@Injectable()
export class SignupModel {

    token: string;

    signupStatus: SignupStatusData;

    activePage: SignupPages = SignupPages.WELCOME;

    constructor(private signupService: SignupService) {
    }

    get venueId(): string {
        return this.signupStatus.venueId;
    }

    async load(token: string, activePage?: SignupPages): Promise<void> {
        try {
            this.token = token;
            this.signupStatus = await this.signupService.getSignupStatus(token);
            this.activePage = activePage !== undefined ? activePage
                : !this.signupStatus.requiresContract && this.signupStatus.requiresBilling ? SignupPages.BILLING
                : this.signupStatus.requiresContract || this.signupStatus.requiresBilling ? SignupPages.WELCOME
                    : SignupPages.COMPLETE;
        } catch (e) {
            console.log(e);
            if (e.status === 401) {
                this.activePage = SignupPages.EXPIRED;
            } else {
                this.activePage = SignupPages.FAILED;
            }
        }
    }

    async confirmContractDone(): Promise<void> {
        this.activePage = SignupPages.BILLING;
    }

    async confirmBilling(): Promise<void> {
        await this.refresh(SignupPages.COMPLETE);
    }

    async refresh(activePage: SignupPages): Promise<void> {
        await this.load(this.token, activePage);
    }
}
